var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Component, DIV } from '../../lib/dom';
import { Canvas, EventEmitter } from '../../lib/classes';
import { emitter } from '../../app';
var CanvasGame = /** @class */ (function (_super) {
    __extends(CanvasGame, _super);
    function CanvasGame(props) {
        var _this = _super.call(this, props) || this;
        _this.drawCounter = 0;
        _this.needRedraw = true;
        _this.paused = false;
        _this.beforeEffects = {};
        _this.afterEffects = {};
        _this.emitter = new EventEmitter();
        _this.effectId = 0;
        _this.loopCounter = 0;
        _this.lowFpsCounter = 0;
        _this.loop = function (time) {
            if (time && _this.time) {
                var dt = Math.min(100, time - _this.time);
                if (dt > 0) {
                    if (!_this.paused) {
                        _this.animate(dt, time);
                    }
                    _this.draw(dt, _this.needRedraw);
                    _this.needRedraw = false;
                    _this.lowFpsCounter = Math.max(0, _this.lowFpsCounter + (dt > 33 ? 1 : -1));
                    _this.lowFpsCounter === 25 && setTimeout(function () { return _this.emitter.emit('lowFps', {}); }, 1);
                }
                _this.loopCounter++;
            }
            _this.time = time;
            requestAnimationFrame(_this.loop);
        };
        var _a = _this.props.viewPort.getSize(), w = _a.w, h = _a.h;
        _this.scene = new Canvas(w, h);
        _this.scene.canvas.className = 'Game__scene';
        if (DEVELOPMENT)
            _this.scene.canvas.setAttribute('data-name', 'scene');
        _this.el = _this.getEl();
        _this.props.viewPort.onChange(function () { return _this.onResize(); });
        setTimeout(function () { return requestAnimationFrame(_this.loop); }, 1);
        emitter.on('lang', function (_lang) {
            _this.needRedraw = true;
        });
        return _this;
    }
    CanvasGame.prototype.getEl = function () {
        return new DIV('Game', [this.scene.canvas]);
    };
    CanvasGame.prototype.pause = function () {
        this.paused = true;
    };
    CanvasGame.prototype.resume = function () {
        this.paused = false;
    };
    CanvasGame.prototype.on = function (name, cb) {
        this.emitter.on(name, cb);
    };
    CanvasGame.prototype.addAfterEffect = function (effect) {
        var key = String(++this.effectId);
        this.afterEffects[key] = effect;
    };
    CanvasGame.prototype.addBeforeEffect = function (effect) {
        var key = String(++this.effectId);
        this.beforeEffects[key] = effect;
    };
    CanvasGame.prototype.promisifyEffect = function (Effect, props, before) {
        var _this = this;
        return new Promise(function (resolve) {
            var effect = new Effect(__assign(__assign({}, props), { onDone: function (data) { return resolve(data); } }));
            before ? _this.addBeforeEffect(effect) : _this.addAfterEffect(effect);
        });
    };
    CanvasGame.prototype.onResize = function () {
        this.resizeScene(this.scene);
        this.needRedraw = true;
        this.resizeTime = Date.now();
    };
    CanvasGame.prototype.resizeScene = function (scene) {
        var _a = this.props.viewPort.getPoint(), x = _a.x, y = _a.y;
        var _b = this.props.viewPort.getSize(), w = _b.w, h = _b.h;
        scene.canvas.style.left = "".concat(x, "px");
        scene.canvas.style.top = "".concat(y, "px");
        scene.resize(w, h);
    };
    CanvasGame.prototype.animate = function (dt, time) {
        this.animateEffects(this.beforeEffects, dt);
        this.animateEffects(this.afterEffects, dt);
    };
    CanvasGame.prototype.animateEffects = function (effects, dt) {
        for (var key in effects) {
            if (effects.hasOwnProperty(key)) {
                var effect = effects[key];
                effect.upd(dt);
                this.needRedraw = effect.needRedraw();
                if (effect.isDone())
                    delete effects[key];
            }
        }
    };
    CanvasGame.prototype.draw = function (_time, needRedraw) {
        if (needRedraw) {
            this.drawCounter++;
            this.drawBackground();
            this.drawEffects(this.beforeEffects);
            this.drawScene();
            this.drawEffects(this.afterEffects);
        }
    };
    CanvasGame.prototype.drawBackground = function () { };
    CanvasGame.prototype.drawScene = function () {
        this.scene.fillAll('#000');
    };
    CanvasGame.prototype.drawEffects = function (effects) {
        for (var key in effects) {
            if (effects.hasOwnProperty(key)) {
                effects[key].draw(this.scene);
            }
        }
    };
    return CanvasGame;
}(Component));
export { CanvasGame };
